module.exports = __webpack_public_path__ + "d57c8bee664f315e2b89181d706d4af8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C0000152W.png
// module id = 1469
// module chunks = 0